/*
 * Copyright (c) Nexign, JSC, 2019-2025.
 */
/**
 * Helmet (dynamic page title)
 *
 * @author Misha Kokoulin
 * @author Maxim Fedorov
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Nikolay Sviridov
 * @version 1.38.0
 * @since 1.0.1
 */

import get from 'lodash/get';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { ValueOf } from '@/main/types/globalTypes';
import { makeSelectTranslationCommon } from '@modules/internationalization/intSelectors';
import { ICommonTranslationPages } from '@modules/internationalization/types/common/pages';
import { IRootReducer } from '@reducers/rootReducer';

import ICommonTranslation from '../../../modules/internationalization/types/common';

interface ITitleOwnProps {
    pageName: ValueOf<ICommonTranslationPages>;
}

interface ITitleConnectedProps {
    translation: ICommonTranslation;
}

type TTitle = ITitleOwnProps & ITitleConnectedProps;

const Title = (props: TTitle) => {
    return (
        <Helmet>
            <title>{get(props.translation.pages, props.pageName, 'B2B PORTAL')}</title>
        </Helmet>
    );
};

const mapStateToProps = createStructuredSelector<IRootReducer, ITitleConnectedProps>({
    translation: makeSelectTranslationCommon(),
});

export default connect(mapStateToProps)(Title);
